import styles from './nonews.module.css';
import classNames from 'classnames';
function NoNews({ layout = 'vertical', textinput = 'news' }) {

    let text = "Die Nachricht konnte nicht geladen werden."
    if (layout === 'horizontal' && textinput === 'news') {
        text = "Die Nachrichten konnten nicht geladen werden."
    } else if (layout === 'horizontal' && textinput === 'matches') {
        text = "Die Spielübersicht konnte nicht geladen werden."
    }

    return (
        <div className={classNames(styles.container, {
            [styles.horizontal]: layout === 'horizontal',
            [styles.vertical]: layout === 'vertical',
        })}>
            <div>
                <img src='/assets/icons/warning.png' alt='Warnung-Symbol'></img>
            </div>
            <p className={styles.text}>{text}</p>
        </div>
    );
}

export default NoNews;